// extracted by mini-css-extract-plugin
export default {"container":"main-menu_container__3yeZD","visible":"main-menu_visible__1SfRq","fadeInSlow":"main-menu_fadeInSlow__3AUiq"};